/**
 * Plugin Configuration Hook
 * Uses PluginConfigUtils for business logic
 */
import { useMemo } from 'react';
import { useTagadaContext } from '../providers/TagadaProvider';
import { PluginConfigUtils } from '../../core/utils/pluginConfig';
export function usePluginConfig(options = {}) {
    const { pluginConfig, pluginConfigLoading } = useTagadaContext();
    const config = useMemo(() => {
        const baseConfig = PluginConfigUtils.getPluginConfig(options.rawConfig, {
            storeId: pluginConfig.storeId,
            accountId: pluginConfig.accountId,
            basePath: pluginConfig.basePath,
        });
        // Merge config properties from the loaded plugin config
        return {
            ...baseConfig,
            ...pluginConfig.config,
            storeId: pluginConfig.storeId,
            accountId: pluginConfig.accountId,
            basePath: pluginConfig.basePath,
        };
    }, [options.rawConfig, pluginConfig]);
    const isValid = useMemo(() => {
        return PluginConfigUtils.validateConfig(config);
    }, [config]);
    return {
        config,
        storeId: config.storeId,
        accountId: config.accountId,
        basePath: config.basePath,
        loading: pluginConfigLoading,
        error: undefined, // TODO: Add error handling if needed
        isValid,
    };
}
